import React from 'react'
import PdfPage from '../../components/PdfPage/PdfPage'
import { TERMS_AND_CONDITIONS_PDF_URL } from '../../constants'

const TermsAndConditions = () => <PdfPage title="Terms of Service" file={TERMS_AND_CONDITIONS_PDF_URL} />

export default TermsAndConditions
